import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { verifyEmail } from '../api/auth';

const STATUS = { PENDING: 'pending', OK: 'ok', ERROR: 'error' };

export default function VerifyEmail() {
    const [searchParams] = useSearchParams();
    const [state, setState] = useState(STATUS.PENDING);
    const [message, setMessage] = useState('');
    // StrictMode double-invokes effects in development. The backend answers 200
    // for an already-verified user so a second call is harmless, but there is
    // no reason to make it.
    const requested = useRef(false);

    useEffect(() => {
        if (requested.current) return;
        requested.current = true;

        const uid = searchParams.get('uid');
        const token = searchParams.get('token');
        if (!uid || !token) {
            setState(STATUS.ERROR);
            setMessage('This link is not valid.');
            return;
        }

        verifyEmail({ uid, token })
            .then(() => setState(STATUS.OK))
            .catch((error) => {
                setState(STATUS.ERROR);
                setMessage(
                    error.response?.data?.detail ||
                        'We could not confirm your email. Please try again.',
                );
            });
    }, [searchParams]);

    return (
        <div className="verify-email-page">
            {state === STATUS.PENDING && <p role="status">Confirming your email…</p>}
            {state === STATUS.OK && (
                <p role="status">Your email is confirmed. Thank you!</p>
            )}
            {state === STATUS.ERROR && <p role="alert">{message}</p>}
            <Link to="/" className="auth-link">
                Back to home
            </Link>
        </div>
    );
}
